var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ek-table',{attrs:{"items":_vm.userList,"columns":_vm.userCols,"deleteBtn":""},on:{"details":_vm.detailsUser,"delete-selected":_vm.deleteUsers},scopedSlots:_vm._u([{key:"items.dateCreated",fn:function(ref){
var value = ref.value;
return [_vm._v(" "+_vm._s(value ? new Date(value).toLocaleDateString() : "")+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }